module.exports = __webpack_public_path__ + "static/fonts/Roboto700.7c181887.ttf";